<template>
    <div id="modal" v-if="display">
        <form  action="" @submit.prevent="send">
            <h3>Adicionar Lance</h3>
            <a class="close" @click.prevent="closeModal()" href="#">X</a>
            <div class="result success" v-if="result=='success'">
                Envio realizado com sucesso.
            </div>
            <div class="result error" v-if="result=='error'">
                Ocorreu ao enviar. Tente novamente.
            </div>
            <div class="row contact-form-block">
                <div class="col-6">
                    <div class="contact-input-wrapper">
                        <select 
                            class="contact-form-input"
                            v-model="form.moment"
                            required>
                            <option :value="null">-- Momento --</option>
                            <option 
                                :value="option.key" 
                                v-for="option in moment_options" 
                                :key="option.key">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-6">
                    <div>
                        <input 
                            type="number"
                            class="contact-form-input" 
                            id="id_minute" 
                            name="minute" 
                            placeholder="Minuto"
                            v-model.number="form.minute"
                            required />
                    </div>
                </div>
                <div class="col-12">
                    <div class="contact-input-wrapper">
                        <select 
                            class="contact-form-input"
                            v-model="form.throw_type"
                            required>
                            <option :value="null">-- Tipo do Lance --</option>
                            <option 
                                :value="option.key" 
                                v-for="option in throw_type_options" 
                                :key="option.key">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>
                </div>
                <template v-if="active_player.includes(form.throw_type)">
                    <div class="col-12">
                        <div class="contact-input-wrapper">
                            <select 
                                class="contact-form-input"
                                v-model="form.team">
                                <option :value="null">-- Time --</option>
                                <option 
                                    :value="option.key" 
                                    v-for="option in teams" 
                                    :key="option.key">
                                    {{ option.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <template v-if="form.team">
                        <div class="col-6">
                            <div class="contact-input-wrapper">
                                <select 
                                    class="contact-form-input"
                                    v-model="form.player">
                                    <option :value="null">-- Jogador --</option>
                                    <option 
                                        :value="option.key" 
                                        v-for="option in player_options" 
                                        :key="option.key">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6" v-if="form.throw_type == 'replacement'">
                            <div class="contact-input-wrapper">
                                <select 
                                    class="contact-form-input"
                                    v-model="form.bench">
                                    <option :value="null">-- Banco --</option>
                                    <option 
                                        :value="option.key" 
                                        v-for="option in bench_options" 
                                        :key="option.key">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </template>
                </template>
                <div class="col-12">
                    <div >
                        <input 
                            class="contact-form-input" 
                            id="id_title" 
                            name="title" 
                            placeholder="Título"
                            v-model="form.title" />
                    </div>
                </div>
                <div class="col-12">
                    <div class="contact-input-wrapper contact-textarea-wrapper">
                        <textarea 
                            class="contact-form-textarea" 
                            id="id_text" 
                            name="text" 
                            rows="6"
                            placeholder="Texto"
                            v-model="form.text" />
                    </div>
                </div>
                <div class="col-12">
                    <div class="contact-input-wrapper">
                        <input 
                            type="file"
                            class="contact-form-input" 
                            id="id_image" 
                            name="image" 
                            @change="setImage" />
                        <label>Imagem</label>
                    </div>
                    <span v-if="filename" style="font-size:12px">Imagem escolhida: {{filename}}</span>
                    
                </div>
                <div class="col-12">
                    <div class="contact-input-wrapper">
                        <input 
                            class="contact-form-input" 
                            id="id_video" 
                            name="video"
                            placeholder="Vídeo do Youtube"
                            v-model="form.video" />
                    </div>
                </div>
                <div class="col-12">
                    <div class="contact-input-wrapper contact-textarea-wrapper">
                        <textarea 
                            class="contact-form-textarea" 
                            id="id_embed" 
                            name="embed" 
                            rows="6"
                            placeholder="Embed Twitter"
                            v-model="form.embed" />
                    </div>
                </div>
                <div class="col-12">
                    <input class="contact-submit-btn" type="submit" value="Enviar">
                </div>
            </div>
        </form>
        <div class="overlay"></div>
    </div>
</template>

<script>
import api from '@/api/asgi'

export default {
    name:'LanceForm',
    props:[
        'page_id', 'token', 'teams', 
        'squad_home', 'squad_home_bench', 
        'squad_visitor', 'squad_visitor_bench',
        'display'
    ],
    data () {
        return {
            search:'',
            lance_id: null,
            form:{
                moment: null,
                minute: null,
                throw_type: null,
                player: null,
                bench: null,
                team:null,
                title: null,
                text: null,
                image: null,
                video: null,
                embed: null,
            },
            players: null,
            selected_player: null,
            active_player:['goal', 'replacement', 'yellow', 'red'], 
            throw_type_options: [
                {key:'normal', label:'Normal'},
                {key:'goal', label:'Gol'},
                {key:'yellow', label:'Cartão Amarelo'},
                {key:'red', label:'Cartão Vermelho'},
                {key:'replacement', label:'Substituição'},
                {key:'kick', label:'Na trave'},
            ],
            moment_options:[
                {key:'0PRE', label:'Pré-Jogo'},
                {key:'1', label:'1º Tempo'},
                {key:'1TO', label:'1º Tempo Prorrogação'},
                {key:'1END', label:'Fim do 1º Tempo'},
                {key:'1ENDP', label:'Fim do 1º Tempo da Prorrogação'},
                {key:'2', label:'2º Tempo'},
                {key:'2TO', label:'2º Tempo Prorrogação'},
                {key:'2END', label:'Fim do 2º Tempo'},
                {key:'2ENDP', label:'Fim do 2º Tempo da Prorrogação'},
                {key:'3OVER', label:'Fim de Jogo'},
            ],
            result: null,
            close: true,
            filename:null,
        }
    },
    computed:{
        squad_home_options: function () {
            return this.squad_home.map(value => {
                return {key:value.player.id, label:value.player.name}
            })
        },
        squad_visitor_options: function () {
            return this.squad_visitor.map(value => {
                return {key:value.player.id, label:value.player.name}
            })
        },
        squad_home_bench_options: function () {
            return this.squad_home_bench.map(value => {
                return {key:value.player.id, label:value.player.name}
            })
        },
        squad_visitor_bench_options: function () {
            return this.squad_visitor_bench.map(value => {
                return {key:value.player.id, label:value.player.name}
            })
        },
        player_options: function () {
            if (this.form.team == 'home') {
                return this.squad_home_options
            } else if (this.form.team == 'visitor') {
                return this.squad_visitor_options
            }
            return []
        },
        bench_options: function () {
            if (this.form.team == 'home') {
                return this.squad_home_bench_options
            } else if (this.form.team == 'visitor') {
                return this.squad_visitor_bench_options
            }
            return []
        }
    },
    watch:{
        search: async function() {
            if (this.search.length > 3) {
                this.selected_player = null
                const response = await api.get(`players/`, {
                    fields: 'name',
                    search: this.search,
                    limit:5
                })
    
                if (response.ok) {
                    this.players = response.data.items
                }
            } else {
                this.players = null
            }
        },
    },
    methods:{
        setImage(event) {
            if (event.target.files.length) {
                this.form.image = event.target.files[0]
                this.filename = this.form.image.name
            }
        },
        reset(){
            this.form = {
                moment: null,
                minute: null,
                throw_type: null,
                title: null,
                text: null,
                image: null,
                video: null,
                embed: null,
            }
            this.search = ''
            this.players = null
            this.lance_id = null
        },
        async send() {
            let formData = new FormData()
            formData.append('realtime', this.page_id)
            formData.append('moment', this.form.moment)
            formData.append('minute', parseInt(this.form.minute))
            formData.append('throw_type', this.form.throw_type)
            formData.append('embed', this.form.embed || '')
            formData.append('title', this.form.title)
            formData.append('text', this.form.text || '')
            if (this.form.player) {
                formData.append('player', this.form.player)
            }
            if (this.form.bench) {
                formData.append('bench', this.form.bench)
            }
            if (this.form.image) {
                formData.append('image', this.form.image)
            }
            if (this.form.video) {
                formData.append('video', this.form.video)
            }

            this.form.page_id = this.page_id
            const headers = {
                Authorization: `Token ${this.token}`
            }
            let response = null
            if (!this.lance_id){
                response = await api.post('lancealance/', formData, {
                    headers: headers
                })
            } else {
                response = await api.put(`lancealance/${this.lance_id}/`, formData, {
                    headers: headers
                })
            }

            if (response.ok) {
                this.closeModal()
            } else {
                this.result = 'error'
            }
        },
        selectPlayer(player){
            this.selected_player = player

            if (player == null) {
                window.setTimeout(() => {
                    document.getElementById('id_player').focus()
                }, 100);
            }
        },
        focusOut(){
            window.setTimeout(() => {
                if (!this.selected_player) {
                    this.search = ''
                }
            }, 100);
        },
        keyPressed(evt){
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                document.getElementById('id_player').blur()
            }
        },
        closeModal(){
            this.reset()
            this.$root.$emit('modal:close')
        },
        async loadLance(id) {
            this.reset()
            const response = await api.get(`lancealance/${id}/`,{},{
                headers:{Authorization: `Token ${this.token}`}
            })

            if (response.ok) {
                this.lance_id = response.data.id
                this.form.moment = response.data.moment
                this.form.minute = parseInt(response.data.minute)
                this.form.throw_type = response.data.throw_type
                this.form.title = response.data.title
                this.form.text = response.data.text
                this.form.embed = response.data.embed
                if (response.data.image){
                    this.filename = response.data.image.file
                }
                if (response.data.player){
                    this.form.player = response.data.player.id
                    this.squad_home_options.forEach(element => {
                        if (response.data.player.name == element.label) {
                            this.form.team = 'home'
                        }
                    }); 
                    if (!this.form.team){
                        this.form.team = 'visitor'
                    }
                }

                this.$root.$emit('modal:open')
            }
        }
    },
    mounted(){
        this.$root.$on('gazetaweb:editlance', (id) => {
            this.loadLance(id)
        })
    }
}
</script>

<style>
    #modal{
        position: fixed;
        width: 100%;
        height: 100%;
        top:0;
        bottom:0;
        left: 0;
        z-index: 99999;
    }
    #modal form{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
        z-index: 21;
        background-color: #fff;
        padding: 20px;
        overflow: auto;
        max-height: 90%;
    }
    #modal .overlay{
        position: absolute;
        background-color: #000;
        width: 100%;
        height: 100%;
        z-index: 10;
        opacity: .5;
    }

    .close{
        position: absolute;
        right: 20px;
        top: 20px;
        background-color: #ccc;
        padding: 5px 10px;
        border-radius: 20px;
        font-size:12px;
        color:#fff !important;
        text-decoration: none !important;
    }
    .close:hover{
        background-color:#aaa;
    }
    .autocomplete-wrapper{
        position:relative;
    }

    .autocomplete{
        position: absolute;
        list-style: none;
        margin: 0;
        padding: 0;
        background-color: #fff;
        top: 55px;
        width: 100%;
        border: 1px solid #c1c2c3;
        z-index: 3;
    }

    .autocomplete a{
        display:block;
        padding: 10px;
        text-decoration: none;
    }
    .autocomplete a:hover{
        background-color: #2285d1;
        color: #fff;
    }
    .hidden{
        display:none
    }

    .result{
        padding:10px;
        margin-bottom:20px;
        font-size: 12px;
        color: #fff;
    }

    .result.success{
        background-color: #7bed9f;
    }
    .result.error{
        background-color: #ff4757;
    }
</style>